export enum PaymentProviderEnum {
  Unspecified = 0,
  InternalTransfer,
  UnknownBank,
  Neteller = 10,
  PaySafe = 20,
  Skrill = 30,
  DSK = 40,
  Epay = 50,
  Stripe = 60,
  Revolut = 70,
  Bvnk = 80,
  Solana = 90,
}
